import styled from '@emotion/styled'

export const StyleGroupCheckboxItems = styled.div`
  display: flex;
  flex-flow: row wrap;
  row-gap: 20px;
  column-gap: 30px;
  align-items: center;
`

export const StyleGroupCheckboxItem = styled.div<any>`
  display: flex;
  align-items: center;
  column-gap: 5px;
  ${(props: any) => props.styleItem};
`

export const StyleCheckbox = styled.input``

export const StyleCheckboxLabel = styled.p`
  font-size: 14px;
  color: #000;
`
